import React, { useEffect, useState } from 'react';
import TabWrapper from './TabWrapper';
import { getListCodebaseByDao } from 'redux/actions/daoUI/codebase.action';
import CodebaseDetailModal from './CodebaseDetailModal';

const CodebaseTab = ({ daoOrganizerAddress, daoId, chainId, daoInfo }) => {
  const [codebases, setCodebases] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [total, setTotal] = useState(0);
  const [openDetail, setOpenDetail] = useState(false);
  const [selectedCodebase, setSelectedCodebase] = useState(null);
  const [isCreateMode, setIsCreateMode] = useState(false);

  useEffect(() => {
    const fetchCodebases = async () => {
      setLoading(true);
      setError(null);
      try {
        const params = {
          daoId,
          chainId,
          page,
          limit
        };
        const data = await getListCodebaseByDao(params)();
        setCodebases(data?.data || []);
        setTotal(data?.pagination?.total || 0);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };
    if (daoOrganizerAddress && chainId) fetchCodebases();
  }, [daoOrganizerAddress, chainId, page, limit]);

  const handleCreateNew = () => {
    setIsCreateMode(true);
    setSelectedCodebase(null);
    setOpenDetail(true);
  };

  const handleCloseModal = () => {
    setOpenDetail(false);
    setIsCreateMode(false);
    setSelectedCodebase(null);
  };

  const reloadCodebases = () => {
    setPage(1); // Reset to page 1
    const params = {
      daoId,
      chainId,
      page: 1,
      limit
    };
    getListCodebaseByDao(params)()
      .then(data => {
        setCodebases(data?.data || []);
        setTotal(data?.pagination?.total || 0);
      })
      .catch(err => {
        setError(err);
      });
  };

  return (
    <TabWrapper daoOrganizerAddress={daoOrganizerAddress} chainId={chainId}>
      {loading && <div>Loading...</div>}
      {error && <div style={{ color: 'red' }}>{error}</div>}
      {!loading && !error && (
        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
            <h3 style={{ color: '#03edc3' }}>Codebase List</h3>
          </div>
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'separate', borderSpacing: 0, marginTop: '20px', background: '#23272f', color: '#00ffe0', borderRadius: 8, overflow: 'hidden', boxShadow: '0 2px 8px #0006' }}>
              <thead>
                <tr style={{ backgroundColor: '#181c22' }}>
                  <th style={{ padding: '14px', textAlign: 'left', borderBottom: '2px solid #00ffe0', color: '#00ffe0', fontWeight: 600 }}>Name</th>
                  <th style={{ padding: '14px', textAlign: 'left', borderBottom: '2px solid #00ffe0', color: '#00ffe0', fontWeight: 600 }}>Created</th>
                  <th style={{ padding: '14px', textAlign: 'left', borderBottom: '2px solid #00ffe0', color: '#00ffe0', fontWeight: 600 }}>Updated</th>
                </tr>
              </thead>
              <tbody>
                {codebases.map((codebase, idx) => (
                  <tr key={codebase._id}
                    style={{ borderBottom: '1px solid #00ffe0', background: idx % 2 === 0 ? '#23272f' : '#181c22', transition: 'background 0.2s', cursor: 'pointer' }}
                    onMouseOver={e => e.currentTarget.style.background = '#26313a'}
                    onMouseOut={e => e.currentTarget.style.background = idx % 2 === 0 ? '#23272f' : '#181c22'}
                    onClick={() => { setSelectedCodebase(codebase); setOpenDetail(true); }}
                  >
                    <td style={{ padding: '12px', color: '#fff' }}>{codebase.name}</td>
                    <td style={{ padding: '12px', color: '#fff' }}>
                      {codebase.createdAt ? new Date(codebase.createdAt).toLocaleDateString() : 'Not specified'}
                    </td>
                    <td style={{ padding: '12px', color: '#fff' }}>
                      {codebase.updatedAt ? new Date(codebase.updatedAt).toLocaleDateString() : 'Not specified'}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {codebases.length === 0 && !loading && (
            <div style={{ textAlign: 'center', padding: '40px', color: '#6c757d' }}>
              No codebases found. Click "Create New Codebase" to get started.
            </div>
          )}
          <div style={{ marginTop: '20px' }}>
            <button 
              onClick={() => setPage(p => Math.max(1, p - 1))}
              disabled={page === 1}
              style={{
                padding: '8px 16px',
                backgroundColor: '#00ffe0',
                color: '#181c22',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                fontWeight: 'bold',
                marginRight: '10px',
                opacity: page === 1 ? 0.5 : 1
              }}
            >
              Previous Page
            </button>
            <span style={{ margin: '0 10px', color: '#fff' }}>Page {page}</span>
            <button 
              onClick={() => setPage(p => p + 1)}
              disabled={page >= Math.ceil(total / limit)}
              style={{
                padding: '8px 16px',
                backgroundColor: '#00ffe0',
                color: '#181c22',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                fontWeight: 'bold',
                opacity: page >= Math.ceil(total / limit) ? 0.5 : 1
              }}
            >
              Next Page
            </button>
          </div>
          <CodebaseDetailModal 
            open={openDetail} 
            onClose={handleCloseModal} 
            codebase={selectedCodebase}
            isCreateMode={isCreateMode}
            daoId={daoId}
            chainId={chainId}
            daoInfo={daoInfo}
            onSuccess={reloadCodebases}
          />
        </div>
      )}
    </TabWrapper>
  );
};

export default CodebaseTab;
